'use client'
import { Box, Button, Typography } from '@/CommonComponents'
import { useRouter } from 'next/navigation'
import Logo from './Logo'
import { COLORS } from '@/lib/constants/colors'

const CARD_STYLE = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  width: '100vw',
  textAlign: 'center',
  gap: 3,
  p: 3,
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
}

const CONTENT_STYLE = {
  position: 'relative',
  zIndex: 1,
  backgroundColor: COLORS.BACKGROUND.LIGHT,
  borderRadius: '16px',
  p: { xs: 3, md: 6 },
  maxWidth: 'sm',
  width: '100%',
  backdropFilter: 'blur(8px)',
  border: `1px solid ${COLORS.BACKGROUND.DARK}`,
}

const LOGO_STYLE = {
  position: 'fixed',
  bottom: 24,
  right: 24,
  zIndex: 2,
  opacity: 0.8,
  transition: 'opacity 0.2s ease-in-out',
  '&:hover': {
    opacity: 1,
  },
}

export default function ErrorPage({
  error,
  title = 'An error occurred',
  showBackButton = true,
}: {
  error: string
  title?: string
  showBackButton?: boolean
}) {
  const router = useRouter()

  return (
    <Box sx={CARD_STYLE}>
      <Box sx={CONTENT_STYLE}>
        <Typography variant="h6" color="error">
          {title}
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            mb: 4,
            fontSize: { xs: '1rem', md: '1.1rem' },
            lineHeight: 1.6,
          }}
        >
          {error}
        </Typography>

        {showBackButton && (
          <Button
            onClick={() => {
              router.back()
            }}
            label="BACK"
            icon="arrow-back"
          />
        )}
      </Box>
      <Box sx={LOGO_STYLE}>
        <Logo width={120} height={40} />
      </Box>
    </Box>
  )
}
